import { enqueueSnackbar, DownloadFile } from 'actions';
import {
	tefImportRequest, tefImportSuccess, tefImportFailure,
	tefGetLastUpdateRequest, tefGetLastUpdateSuccess, tefGetLastUpdateFailure,
	tefGenerateRequest, tefGenerateSuccess, tefGenerateFailure,
	tefSendEmailsRequest, tefSendEmailsSuccess, tefSendEmailsFailure,
	tefExtensionsHistoryRequest, tefExtensionsHistorySuccess, tefExtensionsHistoryFailure,
	repoImportRequest, repoImportSuccess, repoImportFailure,
	repoGetLastUpdateRequest, repoGetLastUpdateSuccess, repoGetLastUpdateFailure,
	repoExportRequest, repoExportSuccess, repoExportFailure,
} from '../actions/tefInternalActions';
import {
	TefImportFileRequest,
	TefGetLastUpdateRequest,
	TefGenerateResultRequest,
	TefSendEmailsRequest,
	TefGetExtensionsHistoryRequest,
	RepoImportRequest,
	RepoGetLastUpdateRequest,
	RepoExportRequest,
} from '../requests/TefInternalRequests';

// ─── TEF INTERNAL PROCESS ─────────────────────────────────────────────────────

export const tefGetLastUpdate = () => async (dispatch) => {
	dispatch(tefGetLastUpdateRequest());
	await TefGetLastUpdateRequest().then((response) => {
		const raw = response.data?.tefInternalLastUpdate ?? response.data?.TefInternalLastUpdate;
		dispatch(tefGetLastUpdateSuccess({
			user:      raw?.insertUser ?? raw?.InsertUser ?? null,
			timestamp: raw?.insertDate ?? raw?.InsertDate ?? null,
		}));
	}).catch((error) => {
		dispatch(tefGetLastUpdateFailure(error?.message));
	});
};

export const tefImportFile = (userId, file) => async (dispatch) => {
	dispatch(tefImportRequest());
	await TefImportFileRequest(userId, file).then((response) => {
		dispatch(tefImportSuccess(response.data));
		dispatch(enqueueSnackbar({ message: 'File imported successfully.', options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(tefImportFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};

export const tefGenerateResult = (userId) => async (dispatch) => {
	dispatch(tefGenerateRequest());
	await TefGenerateResultRequest(userId).then((response) => {
		dispatch(tefGenerateSuccess(response.data));
		dispatch(DownloadFile(response.data));
		dispatch(enqueueSnackbar({ message: 'Results generated successfully.', options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(tefGenerateFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};

export const tefSendEmails = (userId, userEmail, testEmails, file) => async (dispatch) => {
	dispatch(tefSendEmailsRequest());
	await TefSendEmailsRequest(userId, userEmail, testEmails, file).then((response) => {
		dispatch(tefSendEmailsSuccess(response.data));
		const message = response.data?.message ?? response.data?.Message ?? 'Emails sent successfully.';
		dispatch(enqueueSnackbar({ message, options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(tefSendEmailsFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};

export const tefGetExtensionsHistory = (userId) => async (dispatch) => {
	dispatch(tefExtensionsHistoryRequest());
	await TefGetExtensionsHistoryRequest(userId).then((response) => {
		dispatch(DownloadFile(response.data));
		dispatch(tefExtensionsHistorySuccess(response.data));
		dispatch(enqueueSnackbar({ message: 'Results generated successfully.', options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(tefExtensionsHistoryFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};

// ─── REPOSITORY ───────────────────────────────────────────────────────────────

export const repoGetLastUpdate = (module) => async (dispatch) => {
	dispatch(repoGetLastUpdateRequest());
	await RepoGetLastUpdateRequest(module).then((response) => {
		const list = Array.isArray(response.data) ? response.data : [];
		const sorted = [...list].sort((a, b) => {
			const dateA = new Date(a.insertDate ?? a.InsertDate ?? 0);
			const dateB = new Date(b.insertDate ?? b.InsertDate ?? 0);
			return dateB - dateA;
		});
		const raw = sorted[0] ?? null;
		dispatch(repoGetLastUpdateSuccess({
			lastUpdate: {
				user:      raw?.insertUser ?? raw?.InsertUser ?? null,
				timestamp: raw?.insertDate ?? raw?.InsertDate ?? null,
				file:      raw?.fileName   ?? raw?.FileName   ?? null,
			},
			list: sorted.map((item) => ({
				user:      item?.insertUser ?? item?.InsertUser ?? null,
				timestamp: item?.insertDate ?? item?.InsertDate ?? null,
				file:      item?.fileName   ?? item?.FileName   ?? null,
			})),
		}));
	}).catch((error) => {
		dispatch(repoGetLastUpdateFailure(error?.message));
	});
};

export const repoImport = (userId, module, file) => async (dispatch) => {
	dispatch(repoImportRequest());
	await RepoImportRequest(userId, module, file).then((response) => {
		dispatch(repoImportSuccess(response.data));
		dispatch(enqueueSnackbar({ message: 'Repository imported successfully.', options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(repoImportFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};

export const repoExport = (userId, module) => async (dispatch) => {
	dispatch(repoExportRequest());
	await RepoExportRequest(userId, module).then((response) => {
		dispatch(DownloadFile(response.data));
		dispatch(repoExportSuccess(response.data));
		dispatch(enqueueSnackbar({ message: 'Repository exported successfully.', options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(repoExportFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};